<template>
  <el-container class="layout">
    <div class="mobile-bar">
      <button class="icon-btn" type="button" aria-label="菜单" @click="drawer = true">
        <i class="el-icon-s-fold"></i>
      </button>
      <div class="mobile-brand">{{ clubShort }}</div>
      <el-button type="text" class="logout-btn" @click="logout">退出</el-button>
    </div>

    <el-drawer
      :visible.sync="drawer"
      direction="ltr"
      size="280px"
      :with-header="false"
      custom-class="aw-nav-drawer"
    >
      <aside class="aside aside-drawer">
        <sidebar-brand :club-label="clubLabel" :is-coach="isCoach" />
        <nav-list :groups="menuGroups" :active="activeMenu" @go="go" />
        <aside-foot :username="username" :role-text="roleText" />
      </aside>
    </el-drawer>

    <el-aside width="248px" class="aside desktop-aside">
      <sidebar-brand :club-label="clubLabel" :is-coach="isCoach" />
      <nav-list :groups="menuGroups" :active="activeMenu" @go="go" />
      <aside-foot :username="username" :role-text="roleText" />
    </el-aside>

    <el-container class="main-wrap">
      <el-header class="header desktop-header" height="64px">
        <div class="header-left">
          <h1 class="page-heading">{{ title }}</h1>
          <p v-if="subtitle" class="page-sub">{{ subtitle }}</p>
        </div>
        <div class="header-right">
          <span class="role-badge">{{ roleText }}</span>
          <span class="header-user">{{ username }}</span>
          <el-button type="text" class="logout-btn" @click="logout">退出登录</el-button>
        </div>
      </el-header>
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
const SidebarBrand = {
  name: 'SidebarBrand',
  props: { clubLabel: String, isCoach: Boolean },
  template: `
    <div class="brand-block">
      <div class="brand-mark">{{ isCoach ? '教' : '馆' }}</div>
      <div>
        <div class="brand-name">{{ clubLabel || '课时后台' }}</div>
        <div class="brand-sub">{{ isCoach ? '教练工作台' : '课时与签到' }}</div>
      </div>
    </div>
  `
}

const NavList = {
  name: 'NavList',
  props: { groups: Array, active: String },
  template: `
    <nav class="nav-list">
      <template v-for="group in groups">
        <div v-if="group.label" :key="'g-' + group.label" class="nav-group">{{ group.label }}</div>
        <a
          v-for="item in group.items"
          :key="item.path + item.label"
          :class="['nav-item', { active: isActive(item) }]"
          href="javascript:;"
          @click="$emit('go', item)"
        >
          <i :class="item.icon"></i>
          <span>{{ item.label }}</span>
        </a>
      </template>
    </nav>
  `,
  methods: {
    isActive(item) {
      if (item.kiosk) return false
      if (item.match === 'prefix') return this.active === item.path || this.active.startsWith(item.path + '/')
      return this.active === item.path
    }
  }
}

const AsideFoot = {
  name: 'AsideFoot',
  props: { username: String, roleText: String },
  template: `
    <div class="aside-foot">
      <div class="user-chip">
        <span class="user-dot"></span>
        <span class="user-name">{{ username }}</span>
        <span class="role-badge dim">{{ roleText }}</span>
      </div>
      <router-link class="back-public" to="/">返回公众端</router-link>
    </div>
  `
}

export default {
  name: 'Layout',
  components: { SidebarBrand, NavList, AsideFoot },
  data() {
    return { drawer: false }
  },
  computed: {
    username() {
      return localStorage.getItem('username') || '管理员'
    },
    clubLabel() {
      const name = localStorage.getItem('club_name')
      const code = localStorage.getItem('club_code') || ''
      return name || code || '课时后台'
    },
    clubShort() {
      return this.clubLabel
    },
    isPlatform() {
      return Number(localStorage.getItem('admin_role') || 1) === 9
    },
    isCoach() {
      return Number(localStorage.getItem('admin_role') || 1) === 2
    },
    roleText() {
      if (this.isPlatform) return '运营'
      if (this.isCoach) return '教练'
      return '馆长'
    },
    title() {
      return (this.$route.meta && this.$route.meta.title) || '工作台'
    },
    subtitle() {
      return (this.$route.meta && this.$route.meta.subtitle) || ''
    },
    activeMenu() {
      return this.$route.path.split('?')[0]
    },
    menuGroups() {
      if (this.isCoach) {
        return [
          {
            label: '小课签到',
            items: [
              { path: '/private/scan', label: '拍照签到', icon: 'el-icon-camera', kiosk: true, courseType: 2 },
              { path: '/private/punch', label: '选人签到', icon: 'el-icon-s-check' },
              { path: '/private/records', label: '小课记录', icon: 'el-icon-time' }
            ]
          }
        ]
      }
      const groups = [
        {
          label: '',
          items: [{ path: '/dashboard', label: '工作台', icon: 'el-icon-s-home' }]
        },
        {
          label: '查课时',
          items: [
            { path: '/students', label: '学员课时', icon: 'el-icon-data-analysis' },
            { path: '/enroll', label: '报名录入', icon: 'el-icon-edit' }
          ]
        },
        {
          label: '大课日常',
          items: [
            { path: '/checkin-kiosk', label: '拍照签到', icon: 'el-icon-camera', kiosk: true, courseType: 1 },
            { path: '/manual-check-in', label: '选人签到', icon: 'el-icon-edit-outline' },
            { path: '/group-lesson', label: '大课接龙', icon: 'el-icon-date' },
            { path: '/check-in-records', label: '大课记录', icon: 'el-icon-time' }
          ]
        },
        {
          label: '小课日常',
          items: [
            { path: '/private/scan', label: '拍照签到', icon: 'el-icon-camera', kiosk: true, courseType: 2 },
            { path: '/private/punch', label: '选人签到', icon: 'el-icon-s-check' },
            { path: '/private/students', label: '小课名单/充值', icon: 'el-icon-wallet' },
            { path: '/private/records', label: '小课记录', icon: 'el-icon-document' },
            { path: '/coaches', label: '教练账号', icon: 'el-icon-s-custom' }
          ]
        },
        {
          label: '通知与设置',
          items: [
            { path: '/notify', label: '发通知', icon: 'el-icon-message' },
            { path: '/hour-audit', label: '课时对账', icon: 'el-icon-document-checked' },
            { path: '/settings', label: '系统设置', icon: 'el-icon-setting' }
          ]
        }
      ]
      if (this.isPlatform) {
        groups[groups.length - 1].items.push({
          path: '/clubs',
          label: '内容模块开关',
          icon: 'el-icon-office-building'
        })
      }
      return groups
    }
  },
  methods: {
    go(item) {
      this.drawer = false
      if (item.kiosk) {
        this.openKiosk(item.courseType || 1)
        return
      }
      if (this.$route.path !== item.path) this.$router.push(item.path)
    },
    openKiosk(courseType) {
      const raw = (localStorage.getItem('club_code') || '').trim()
      if (!raw) {
        this.$message.warning('请先登录并绑定俱乐部')
        return
      }
      const code = encodeURIComponent(raw)
      const type = Number(courseType) === 2 ? 2 : 1
      const base = window.location.href.split('#')[0]
      const hash = '#/kiosk?clubCode=' + code + '&courseType=' + type
      const win = window.open(base + hash, '_blank')
      if (!win) {
        this.$router.push({ path: '/kiosk', query: { clubCode: raw, courseType: String(type) } })
      }
    },
    logout() {
      ;['token', 'username', 'admin_role'].forEach(k => localStorage.removeItem(k))
      this.$router.push('/login')
    }
  }
}
</script>

<style>
.layout {
  min-height: 100vh;
  background: var(--aw-paper);
}

.aside {
  background: linear-gradient(180deg, #16302C 0%, #0F1F1C 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: sticky;
  top: 0;
}

.brand-block {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 22px 18px 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.brand-mark {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: linear-gradient(145deg, #14B8A6, #0F766E);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--aw-display);
  font-weight: 700;
  font-size: 18px;
  flex-shrink: 0;
}

.brand-name {
  font-size: 15px;
  font-weight: 700;
  line-height: 1.3;
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.brand-sub {
  margin-top: 2px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
}

.nav-list {
  flex: 1;
  padding: 12px 10px 20px;
  overflow-y: auto;
}

.nav-group {
  margin: 14px 12px 8px;
  font-size: 11px;
  letter-spacing: 0.08em;
  color: rgba(255, 255, 255, 0.38);
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 12px;
  margin-bottom: 4px;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.72);
  text-decoration: none;
  font-size: 14px;
  transition: background 0.15s ease, color 0.15s ease;
}

.nav-item i { font-size: 16px; width: 18px; text-align: center; }

.nav-item:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.nav-item.active {
  background: rgba(20, 184, 166, 0.22);
  color: #fff;
  font-weight: 600;
}

.aside-foot {
  padding: 14px 16px 18px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.user-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
}

.user-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #34D399;
}

.back-public {
  display: block;
  margin-top: 10px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.42);
  text-decoration: none;
}

.back-public:hover { color: #5EEAD4; }

.role-badge {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  background: rgba(20, 184, 166, 0.2);
  color: #5EEAD4;
}

.role-badge.dim {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
}

.main-wrap { min-width: 0; }

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(243, 241, 236, 0.92);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid var(--aw-line);
  padding: 0 28px;
}

.page-heading {
  margin: 0;
  font-size: 20px;
  font-weight: 700;
  font-family: var(--aw-display);
  color: var(--aw-ink);
}

.page-sub {
  margin: 2px 0 0;
  font-size: 12px;
  color: var(--aw-muted);
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-user {
  font-size: 13px;
  color: var(--aw-muted);
}

.logout-btn { color: var(--aw-brand) !important; font-weight: 600; }

.main {
  padding: 22px 28px 40px;
}

.mobile-bar {
  display: none;
  align-items: center;
  gap: 8px;
  height: 56px;
  padding: 0 12px;
  background: #16302C;
  color: #fff;
  position: sticky;
  top: 0;
  z-index: 20;
}

.mobile-brand {
  flex: 1;
  font-weight: 700;
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon-btn {
  border: 0;
  background: transparent;
  color: #fff;
  font-size: 20px;
  padding: 6px;
  cursor: pointer;
}

@media (max-width: 900px) {
  .desktop-aside,
  .desktop-header { display: none; }
  .mobile-bar { display: flex; }
  .main { padding: 16px; }
}
</style>

<style>
.aw-nav-drawer {
  background: transparent !important;
}
.aw-nav-drawer .el-drawer__body {
  padding: 0;
  background: #0F1F1C;
}
.aside-drawer { height: 100%; }
</style>
